<template>
  <div>
    <Form
      page-title="Edit User"
      buttonName="Update"
      :businessId="businessId"
      :isInList="isInList"
      :model="model"
      @showAddChanged="$emit('showAddChanged', $event)"
      @submit="submit"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { updateMenu } from "@/API/MenusAPIs";
import { submitAndNotify } from "@/helpers/utils";
import { updateUser } from "../../../API/UsersAPIs";
export default {
  name: "Edit",
  components: { Form },
  props: ["isInList", "model", "businessId", "showAdd"],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    submit(formData) {
      const callback = () => {
        this.$emit("onSubmit");
        this.$emit("showAddChanged", !this.showAdd);
      };
      submitAndNotify(this, updateUser(formData), callback);
    }
  },
  watch: {
    model: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        this.model.phone_number = {
          formattedNumber: this.model.phone
        };
      }
    }
  }
};
</script>
<style></style>
